<template>
  <div class="change-password-dialog">
    <el-dialog append-to-body :title="row ? '修改账号' : '添加账号'" :visible="isShow" :close-on-click-modal="false" @close="closeDialog" width="600px">
      <el-form class="form" :model="vForm" ref="vForm" label-width="80px" auto-complete="off" size="medium">
        <el-form-item label="昵称" class="form-group" prop="nickname" :rules="{ required: true, message: '昵称必填' }">
          <el-input type="text" class="form-control" v-model="vForm.nickname" />
        </el-form-item>
        <el-form-item label="账号" class="form-group" prop="login_name" :rules="{ required: true, validator: validator.login_name }">
          <el-input type="text" class="form-control" v-model="vForm.login_name" placeholder="用户名至少五位" />
        </el-form-item>
        <el-form-item label="密码" class="form-group" prop="password" :rules="{ required: !!validatorassword, validator: validatorassword }">
          <el-input type="password" class="form-control" :placeholder="this.row ? '选填,不填写不做修改' : '6-16位'" v-model="vForm.password" auto-complete="new-password" />
        </el-form-item>
        <el-form-item label="状态" class="form-group" prop="status">
          <el-radio v-model="vForm.status" :label="1">启用</el-radio>
          <el-radio v-model="vForm.status" :label="2">禁用</el-radio>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeDialog" size="small">取 消</el-button>
        <el-button type="primary" @click="doSubmit" :loading="doSubmitLoading" size="small">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import validator from '../validator';

export default {
  props: ['isShow', 'row'],

  data() {
    return {
      validator,
      validatorassword: this.row ? null : validator.password,
      doSubmitLoading: false,
      vForm: {
        nickname: '',
        id: '',
        login_name: '',
        password: '',
        status: 1,
      },
    };
  },
  created() {
    if (this.row) {
      for (let key in this.vForm) {
        this.vForm[key] = this.row[key];
      }
    }
  },
  methods: {
    closeDialog() {
      this.$emit('update:isShow', false);
    },

    doSubmit() {
      this.$refs.vForm.validate(async (valid) => {
        if (valid) {
          this.doSubmitLoading = true;
          try {
            let res = await this.api.userAdmin[this.row ? 'editAdmin' : 'addAdmin'](this.vForm);
            this.$message.success(res.message);
            this.doSubmitLoading = false;
            this.closeDialog();
            this.$emit('success', this.row ? '' : 1);
          } catch (ex) {
            console.error(ex);
          }
          this.doSubmitLoading = false;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.select-box {
  position: relative;
}

.select-box-handle {
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  cursor: pointer;
}
</style>
